<template>
  <div >
    <div style="text-align: left;"><img class="login-logo" src="../assets/images/login_logo.png" /></div>

    <div class="login-title">空调智能化软件管理系统</div>

    <a class="login-btn" :href="LOGIN_URL">mip账号登录</a>


  </div>
</template>
<style>
html {
  height: 100%;
}

body {
  width: 100%;
  height: 100%;
  margin: 0;
  background: url("../assets/images/login_bg.jpg");
  background-size: 100% 100%;
  text-align: center;
}
.login-logo {
  margin-left: 50px;
  margin-top: 50px;
  width: 120px;
}
.login-title {
  margin-top: 100px;
  font-size: 40px;
  color: #fff;
  font-weight: 800;
  letter-spacing: 2px;
}
.login-btn{
    width: 252px;
    height: 52px;
    line-height: 52px;
    border-radius: 5px;
    font-size: 18px;
    background-color:#fff;
    margin-top: 50px;
    display: inline-block;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    font-family: "Microsoft YaHei", tahoma, verdana, sans-serif;
    border: none;
    padding: 0 12px;
    background-image: none;
    white-space: nowrap;
    user-select: none;
    outline: none;
    transition: all ease-out 0.3s;
}
</style>


<script>
export default {
  data() {
    return {LOGIN_URL: process.env.LOGIN_URL};
  },
  methods: {}
};
</script>
